import { render, staticRenderFns } from "./CustomizationOffer.vue?vue&type=template&id=72d6525a&scoped=true"
import script from "./CustomizationOffer.vue?vue&type=script&lang=js"
export * from "./CustomizationOffer.vue?vue&type=script&lang=js"
import style0 from "./CustomizationOffer.vue?vue&type=style&index=0&id=72d6525a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d6525a",
  null
  
)

export default component.exports